define(['jquery'], function($) {
    'use strict';
    
    var WebRTCAdapterWrapper = {
        // Store original globals
        originalGlobals: {},
        
        // Initialize the adapter safely
        init: function() {
            // Store original globals to prevent conflicts
            this.storeOriginalGlobals();
            
            // Load adapter if not already loaded
            if (!window.adapter) {
                this.loadAdapter();
            }
            
            // Restore original globals
            this.restoreOriginalGlobals();
            
            return window.adapter || {};
        },
        
        // Store original global variables that adapter might modify
        storeOriginalGlobals: function() {
            this.originalGlobals = {
                RTCPeerConnection: window.RTCPeerConnection,
                getUserMedia: window.navigator && window.navigator.mediaDevices ? 
                    window.navigator.mediaDevices.getUserMedia : null,
                webkitGetUserMedia: window.navigator ? window.navigator.webkitGetUserMedia : null,
                mozGetUserMedia: window.navigator ? window.navigator.mozGetUserMedia : null,
                msGetUserMedia: window.navigator ? window.navigator.msGetUserMedia : null
            };
        },
        
        // Restore original globals if needed
        restoreOriginalGlobals: function() {
            // Only restore if adapter didn't properly initialize
            if (!window.adapter || !window.adapter.browserDetails) {
                if (this.originalGlobals.RTCPeerConnection) {
                    window.RTCPeerConnection = this.originalGlobals.RTCPeerConnection;
                }
            }
        },
        
        // Load adapter.js content
        loadAdapter: function() {
            try {
                // Try to load the actual adapter.js file
                var adapterPath = this.findAdapterPath();
                
                if (adapterPath) {
                    this.loadAdapterFile(adapterPath);
                } else {
                    // Fallback to basic shims
                    this.loadBasicShims();
                }
                
            } catch (error) {
                console.warn('Error loading WebRTC adapter:', error);
                this.loadBasicShims();
            }
        },
        
        // Find the adapter.js file
        findAdapterPath: function() {
            var possiblePaths = [
                '/web/vendor/adapter.js',
                '/chat/js/adapter.js',
                '/js/adapter.js',
                '/vendor/adapter.js',
                '../web/vendor/adapter.js',
                '../chat/js/adapter.js'
            ];
            
            // For now, return the most likely path based on context
            if (typeof window !== 'undefined' && window.location) {
                var path = window.location.pathname;
                if (path.includes('/chat/')) {
                    return '../chat/js/adapter.js';
                } else if (path.includes('/web/')) {
                    return '../web/vendor/adapter.js';
                }
            }
            
            return '../web/vendor/adapter.js'; // Default fallback
        },
        
        // Load adapter file
        loadAdapterFile: function(path) {
            // Create a script element to load adapter.js
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = path;
            script.async = false;
            
            // Create a promise to handle loading
            var loadPromise = new Promise(function(resolve, reject) {
                script.onload = resolve;
                script.onerror = reject;
            });
            
            // Add script to document
            document.head.appendChild(script);
            
            // Wait for script to load
            loadPromise.then(function() {
                console.log('WebRTC adapter loaded successfully from:', path);
            }).catch(function(error) {
                console.warn('Failed to load WebRTC adapter from:', path, error);
                // Fallback to basic shims
                WebRTCAdapterWrapper.loadBasicShims();
            });
        },
        
        // Load basic shims as fallback
        loadBasicShims: function() {
            console.log('Loading basic WebRTC shims');
            
            // Basic getUserMedia shim
            if (!window.navigator.mediaDevices) {
                window.navigator.mediaDevices = {};
            }
            
            if (!window.navigator.mediaDevices.getUserMedia) {
                window.navigator.mediaDevices.getUserMedia = function(constraints) {
                    var getUserMedia = window.navigator.webkitGetUserMedia || 
                                     window.navigator.mozGetUserMedia ||
                                     window.navigator.msGetUserMedia;
                    
                    if (!getUserMedia) {
                        return Promise.reject(new Error('getUserMedia is not supported'));
                    }
                    
                    return new Promise(function(resolve, reject) {
                        getUserMedia.call(window.navigator, constraints, resolve, reject);
                    });
                };
            }
            
            // Create a basic adapter object
            window.adapter = {
                browserDetails: this.detectBrowser(),
                commonShim: {},
                extractVersion: function() { return null; },
                disableLog: function() {},
                disableWarnings: function() {}
            };
        },
        
        // Detect browser
        detectBrowser: function() {
            var ua = window.navigator.userAgent;
            var browser = 'unknown';
            var version = null;
            
            if (ua.indexOf('Chrome') !== -1) {
                browser = 'chrome';
            } else if (ua.indexOf('Firefox') !== -1) {
                browser = 'firefox';
            } else if (ua.indexOf('Safari') !== -1) {
                browser = 'safari';
            } else if (ua.indexOf('Edge') !== -1) {
                browser = 'edge';
            }
            
            return {
                browser: browser,
                version: version
            };
        },
        
        // Get adapter instance
        getAdapter: function() {
            return this.init();
        },
        
        // Check if WebRTC is supported
        isSupported: function() {
            return !!(window.RTCPeerConnection || 
                     window.webkitRTCPeerConnection || 
                     window.mozRTCPeerConnection);
        }
    };
    
    // Return the adapter wrapper
    return WebRTCAdapterWrapper;
}); 